import { createSelector } from 'reselect';

const selectBiznetTypes = (state: any) => state.biznetTypes;


export const selectBiznetTypesCurrentItem = createSelector([selectBiznetTypes], (biznetTypes) => biznetTypes.current);

export const selectBiznetTypesListItems = createSelector([selectBiznetTypes], (biznetTypes) => biznetTypes.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectBiznetTypesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectBiznetTypesQueryItems = createSelector([selectBiznetTypes], (biznetTypes) => biznetTypes.query);

export const selectBiznetTypesCreatedItem = createSelector([selectBiznetTypes], (biznetTypes) => biznetTypes.create);

export const selectBiznetTypesUpdatedItem = createSelector([selectBiznetTypes], (biznetTypes) => biznetTypes.update);

export const selectBiznetTypesReadItem = createSelector([selectBiznetTypes], (biznetTypes) => biznetTypes.read);

export const selectBiznetTypesDeletedItem = createSelector([selectBiznetTypes], (biznetTypes) => biznetTypes.delete);

export const selectBiznetTypesSearchedItems = createSelector([selectBiznetTypes], (biznetTypes) => biznetTypes.search);

export const selectBiznetTypesItemsCount = createSelector([selectBiznetTypes], (biznetTypes) => biznetTypes.count);

export const selectBiznetTypesItemsFilter = createSelector([selectBiznetTypes], (biznetTypes) => biznetTypes.filter);